/**
 * Asset selector - selector module
 *
 * This module deals with templating for the photo/video asset thumbnails as well
 * as the preview for a photo/video asset.
 *
 * @author MattJS (matt@yext.com), NQ (nliang@yext.com)
 */
goog.provide('yext.dam.assetselector.selector');

goog.require('goog.string');
goog.require('yext');
goog.require('yext.dam.asset');
// LOOP goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.video');
goog.require('yext.dam.labels.view');
goog.require('yext.imageloader');
goog.require('yext.location.GenericList');
goog.require('yext.location.Struct');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
goog.require('yext.storm.location.util');
goog.require('yext.youtube');

yext.dam.assetselector.selector.UIDString = 'assetUID';
yext.dam.assetselector.selector.thumbnailWidth = 80;
yext.dam.assetselector.selector.thumbnailHeight = 80;
yext.dam.assetselector.selector.youtubeThumbnailWidth = 120;
yext.dam.assetselector.selector.youtubeThumbnailHeight = 90;
yext.dam.assetselector.selector.previewWidth = 225;
yext.dam.assetselector.selector.previewHeight = 310;

/**
 * Stores a reference to the selected asset
 */
yext.dam.assetselector.selector.selected;

/**
 * Initialize selector module
 *
 * @param {!jQuery} $context Some context for searching the dom
 */
yext.dam.assetselector.selector.init = function($context) {
  yext.dam.assetselector.selector.$context = $context;
  yext.dam.assetselector.selector.$assetList = $context.find('.js-asset-list');

  yext.dam.assetselector.selector.$photoTemplate = $($context.find('.js-photo-asset-thumbnail-template').html());
  yext.dam.assetselector.selector.$textTemplate = $($context.find('.js-text-asset-thumbnail-template').html());
  yext.dam.assetselector.selector.$videoTemplate = $($context.find('.js-video-asset-thumbnail-template').html());
  yext.dam.assetselector.selector.$customTemplate = $($context.find('.js-custom-asset-thumbnail-template').html());

  yext.dam.assetselector.selector.$preview = $context.find('.js-asset-selector-preview');
  yext.dam.assetselector.selector.$previewPanels = $context.find('.js-preview-panel');
  yext.dam.assetselector.selector.$photoPreviewPanel = $context.find('.js-photo-preview-panel');
  yext.dam.assetselector.selector.$textPreviewPanel = $context.find('.js-text-preview-panel');
  yext.dam.assetselector.selector.$videoPreviewPanel = $context.find('.js-video-preview-panel');
  yext.dam.assetselector.selector.$customPreviewPanel = $context.find('.js-custom-preview-panel');

  yext.dam.assetselector.selector.$photoPreview = $context.find('.js-photo-preview');
  yext.dam.assetselector.selector.$textPreview = $context.find('.js-text-preview');
  yext.dam.assetselector.selector.$videoPreview = $context.find('.js-video-preview');
  yext.dam.assetselector.selector.$customPreview = $context.find('.js-custom-preview');

  yext.dam.assetselector.selector.$photoPreviewMessage = $context.find('.js-photo-preview-message');
  yext.dam.assetselector.selector.$textPreviewMessage = $context.find('.js-text-preview-message');
  yext.dam.assetselector.selector.$videoPreviewMessage = $context.find('.js-video-preview-message');
  yext.dam.assetselector.selector.$customPreviewMessage = $context.find('.js-custom-preview-message');

  yext.dam.assetselector.selector.$assetDetails = $context.find('.js-asset-details');

  yext.dam.assetselector.selector.bindSelect();
  yext.dam.assetselector.selector.bindPreviewHover();
};

/**
 * Bind click events with delegation
 */
yext.dam.assetselector.selector.bindSelect = function() {
  yext.dam.assetselector.selector.$assetList.on(
    'click',
    '.js-asset-thumbnail, .js-select-video-button',
    function() {
      var $result = $(this).closest('.js-asset-search-result');
      yext.dam.assetselector.selector.selectAsset($result);
      yext.dam.assetselector.selector.$assetList.find('.js-select-video-button').removeClass('disabled');
      $result.find('.js-select-video-button').addClass('disabled');
    });

  $(yext.dam.assetselector.video).on('videoSelected', function(e, video) {
    if (yext.dam.assetselector.selector.selected === undefined) {
      yext.dam.assetselector.selector.selected = {};
    }
    yext.dam.assetselector.selector.selected.videoinfo = video;
  });
};

/**
 * Select Asset
 * @param {jqueryObject} $asset The asset to select
 */
yext.dam.assetselector.selector.selectAsset = function($asset) {
  var asset = yext.dam.assetselector.selector.getAsset($asset);
  var currentSelectedAsset = yext.dam.assetselector.selector.selected;

  // Check that it is not already selected
  if (currentSelectedAsset !== undefined
      && currentSelectedAsset.UID == asset.UID) {
    return;
  }

  yext.dam.assetselector.selector.$assetList.find('.js-asset-thumbnail').removeClass('selected');
  $asset.addClass('selected');
  yext.dam.assetselector.selector.preview(asset);
  yext.dam.assetselector.selector.selected = asset;

  $(yext.dam.assetselector.selector).trigger('selected.assetselector');
};


/**
  * Show the asset details when the preview is hovered
*/

yext.dam.assetselector.selector.bindPreviewHover = function() {
  yext.dam.assetselector.selector.$photoPreviewPanel.hover(function() {
    yext.dam.assetselector.selector.$assetDetails.css({bottom: 0});
  }, function() {
    var height = yext.dam.assetselector.selector.$assetDetails.data('height');
    yext.dam.assetselector.selector.$assetDetails.css({bottom: -1 * height});
  });
};

/**
 * Set the asset type. This overrides some methods to provide polymorphism
 *
 * @param {string} type The asset type
 */
yext.dam.assetselector.selector.setType = function(type) {
  yext.dam.assetselector.selector.type = type;
  yext.dam.assetselector.selector.reset();
  yext.dam.assetselector.selector.$previewPanels.hide();

  if (type === 'PHOTO') {
    yext.dam.assetselector.selector.template = yext.dam.assetselector.selector.photoTemplate;
    yext.dam.assetselector.selector.preview = yext.dam.assetselector.selector.photoPreview;
  } else if (type === 'TEXT') {
    yext.dam.assetselector.selector.template = yext.dam.assetselector.selector.textTemplate;
    yext.dam.assetselector.selector.preview = yext.dam.assetselector.selector.textPreview;
  } else if (type === 'VIDEO') {
    yext.dam.assetselector.selector.template = yext.dam.assetselector.selector.videoTemplate;
    yext.dam.assetselector.selector.preview = yext.dam.assetselector.selector.videoPreview;
  } else if (type === 'CUSTOM') {
    yext.dam.assetselector.selector.template = yext.dam.assetselector.selector.customTemplate;
    yext.dam.assetselector.selector.preview = yext.dam.assetselector.selector.customPreview;
  }

  yext.dam.assetselector.selector.$assetList
    .removeClass('asset-list-text asset-list-photo asset-list-video')
    .addClass('asset-list-' + type.toLowerCase());
};

/**
 * Resets the selection preview
 */
yext.dam.assetselector.selector.resetPreview = function() {
  yext.dam.assetselector.selector.$previewPanels.hide();
  yext.dam.assetselector.selector.$photoPreviewPanel.hide();
  yext.dam.assetselector.selector.$photoPreviewMessage.show();
  yext.dam.assetselector.selector.$photoPreview.hide();
  if (yext.dam.assetselector.selector.selected === undefined) {
    yext.dam.assetselector.selector.$assetDetails.hide();
  }

  if (yext.dam.assetselector.selector.type === 'PHOTO') {
    yext.dam.assetselector.selector.$photoPreviewPanel.show();
    if (yext.dam.assetselector.selector.$assetList.children().length > 1) {
      yext.dam.assetselector.selector.$photoPreviewMessage.show();
      yext.dam.assetselector.selector.$photoPreview.hide();
      yext.dam.assetselector.selector
        .$assetList
        .find('.selected')
        .removeClass('selected');
      yext.dam.assetselector.selector.selected = undefined;
    } else if (yext.dam.assetselector.selector.$assetList.children().length === 1) {
      $(yext.dam.assetselector.selector).trigger('selected.assetselector');
    }
  } else if (yext.dam.assetselector.selector.type === 'TEXT') {
    yext.dam.assetselector.selector.$textPreviewMessage.show();
    yext.dam.assetselector.selector.$textPreviewPanel.show();
    yext.dam.assetselector.selector.$textPreview.hide();
  } else if (yext.dam.assetselector.selector.type === 'VIDEO') {
    yext.dam.assetselector.selector.$videoPreviewPanel.show();
    if (yext.dam.assetselector.selector.$assetList.children().length === 1) {
      $(yext.dam.assetselector.selector).trigger('selected.assetselector');
    }
  } else if (yext.dam.assetselector.selector.type === 'CUSTOM') {
    yext.dam.assetselector.selector.$customPreviewPanel.show();
    if (yext.dam.assetselector.selector.$assetList.children().length === 1) {
      $(yext.dam.assetselector.selector).trigger('selected.assetselector');
    } else {
      yext.dam.assetselector.selector.$customPreviewMessage.show();
    }
  }
};

/**
 * Create a new asset with data provided
 *
 * @param {!Object} data The asset data
 */
yext.dam.assetselector.selector.create = function(data) {
  var asset = yext.dam.asset.create(data);
  var $asset = yext.dam.assetselector.selector.template(asset);
  yext.dam.assetselector.selector.$assetList.append($asset);
  if (yext.dam.assetselector.selector.type === 'PHOTO') {
    $asset.contextualHelp({
      basicText: goog.string.htmlEscape(asset.name),
      event: 'hover',
      width: 'auto',
      propagate: true,
    });
  }
};

/**
 * These two functions will be overridden to provide some polymorphisim
 */
yext.dam.assetselector.selector.template = function() {};
/**
 * Preview
 */
yext.dam.assetselector.selector.preview = function() {};

/**
 * Generate text markup
 * @param {Asset} asset The asset model for which to create a thumbnail
 * @return {!jQuery} The text markup as a jquery object
 */
yext.dam.assetselector.selector.textTemplate = function(asset) {
  var $text = yext.dam.assetselector.selector.$textTemplate.clone();
  $text
    .data(yext.dam.assetselector.selector.UIDString, asset.UID)
    .text(asset.name);
  return $text;
};

/**
 * Generate photo markup
 *
 * @param {Asset} asset The asset model for which to create a thumbnail
 * @return {!jQuery} The photo markup as a jquery object
 */
yext.dam.assetselector.selector.photoTemplate = function(asset) {
  var $photo = yext.dam.assetselector.selector.$photoTemplate.clone();
  $photo
    .data(yext.dam.assetselector.selector.UIDString, asset.UID)
    .append(yext.dam.assetselector.selector.image(asset.photoUrl, yext.dam.assetselector.selector.thumbnailWidth, yext.dam.assetselector.selector.thumbnailHeight));
  return $photo;
};

/**
 * Generate video markup
 *
 * @param {Asset} asset The asset model for which to create a thumbnail
 * @return {!jQuery} The video markup as a jquery object
 */
yext.dam.assetselector.selector.videoTemplate = function(asset) {
  var $video = yext.dam.assetselector.selector.$videoTemplate.clone();
  $video.hide();

  yext.dam.assetselector.selector.video(
    asset.sourceUrl,
    yext.dam.assetselector.selector.youtubeThumbnailWidth,
    yext.dam.assetselector.selector.youtubeThumbnailHeight,
    function(thumbnail) {
      $video
        .data(yext.dam.assetselector.selector.UIDString, asset.UID)
        .find('.js-video-asset-thumbnail')
        .append(thumbnail);
      $video.find('.js-video-result-video-title')
        .html(asset.name);
      $video.find('.js-video-result-video-description')
        .html(asset.description);
      $video.show();
    });

  return $video;
};

/**
 * Generate markup for custom field type assets
 * @param {Asset} asset The asset model for which to create a thumbnail
 * @return {!jQuery} The text markup as a jquery object
 */
yext.dam.assetselector.selector.customTemplate = function(asset) {
  var $custom = yext.dam.assetselector.selector.$customTemplate.clone();
  $custom
    .data(yext.dam.assetselector.selector.UIDString, asset.UID)
    .append(asset.name);
  return $custom;
};

/**
 * Show a video preview for the asset
 *
 * @param {Asset} asset The asset object being previewed
 */
yext.dam.assetselector.selector.videoPreview = function(asset) {
  if (asset && asset.sourceUrl && asset.sourceUrl !== '') {
    yext.dam.assetselector.video.updatePreview(asset.sourceUrl);
  }
};

/**
 * Show a custom preview for the asset
 *
 * @param {Asset} asset The asset object being previewed
 */
yext.dam.assetselector.selector.customPreview = function(asset) {
  if (asset && asset.variant) {
    yext.dam.assetselector.selector.$customPreviewPanel.find('.js-custom-preview-message').hide();
    var context = '.js-custom-preview-content';
    var $customPreviewContent = yext.dam.assetselector.selector.$customPreviewContent;

    if ($customPreviewContent.is('.js-generic-list-context')) {
      // top level generic list
      var genericList = new yext.location.GenericList(
        $customPreviewContent.find('.js-generic-list-edit'),
        context);
      genericList.previewAsset(JSON.parse(asset.variant));
    } else {
      // Fill template with struct data
      var struct = new yext.location.Struct(
        $customPreviewContent.find('.js-struct-edit'),
        context);
      struct.previewAsset(JSON.parse(asset.variant));
    }


    var $content = yext.dam.assetselector.selector.$customPreviewPanel.find(context);
    $content.empty();
    $content.append(yext.dam.assetselector.selector.$customPreviewContent);
    $content.find('.js-edit-buttons').hide();
    yext.dam.assetselector.selector.$customPreviewPanel.show();

    yext.dam.assetselector.selector.$customPreviewPanel.find('.js-custom-asset-name').text(asset.name);
    yext.dam.assetselector.selector.$customPreviewPanel
      .find('.js-asset-labels')
      .html(yext.dam.assetselector.selector.getLabelPreviewMarkup(asset));
    if (asset.description && asset.description !== '') {
      yext.dam.assetselector.selector.$customPreviewPanel
        .find('.js-info-icon')
        .show()
        .contextualHelp({
          basicText: asset.description,
          event: 'hover',
          width: 'auto',
          maxWidth: '150px',
          propagate: true,
        });
    } else {
      yext.dam.assetselector.selector.$customPreviewPanel
        .find('.js-info-icon')
        .hide();
    }
  } else {
    yext.dam.assetselector.selector.$customPreviewPanel.find('.js-custom-preview-message').show();
  }
};

/**
 * Show a photo preview for the asset
 *
 * @param {Asset} asset The asset object being previewed
 */
yext.dam.assetselector.selector.photoPreview = function(asset) {
  var img = yext.dam.assetselector.selector.image(asset.photoUrl, yext.dam.assetselector.selector.previewWidth, yext.dam.assetselector.selector.previewHeight);

  yext.dam.assetselector.selector.$photoPreviewMessage.hide();
  yext.dam.assetselector.selector.$photoPreview.show();

  yext.dam.assetselector.selector.$assetDetails.show();

  yext.dam.assetselector.selector.$photoPreviewPanel.find('.js-photo-preview-image').html('').append(img);
  yext.dam.assetselector.selector.$assetDetails.find('.js-asset-name').text(asset.name);
  yext.dam.assetselector.selector.$assetDetails.find('.js-asset-description').text(asset.description);
  yext.dam.assetselector.selector.$assetDetails.find('.js-asset-url').text(asset.clickthroughUrl || '');
  yext.dam.assetselector.selector.$assetDetails.find('.js-asset-photo-details').text(asset.details || '');

  yext.dam.assetselector.selector.$assetDetails
    .find('.js-asset-labels')
    .html(yext.dam.assetselector.selector.getLabelPreviewMarkup(asset));

  var height = yext.dam.assetselector.selector.$assetDetails.outerHeight();
  yext.dam.assetselector.selector.$assetDetails
    .addClass('no-animate')
    .css({bottom: height * -1})
    .data('height', height);

  // Set timeout stops the description from 'peeking' when the height changes
  setTimeout(function() {
    yext.dam.assetselector.selector.$assetDetails.removeClass('no-animate');
  }, 0);
};

/**
 * Show a text preview for the asset
 *
 * @param {Asset} asset The asset object being previewed
 */
yext.dam.assetselector.selector.textPreview = function(asset) {
  var assetData = asset.data ? goog.string.htmlEscape(asset.data) : '';

  yext.dam.assetselector.selector.$textPreviewMessage.hide();
  yext.dam.assetselector.selector.$textPreview.show();
  yext.dam.assetselector.selector.$textPreviewPanel
    .find('.js-text-asset-name')
    .text(asset.name);
  yext.dam.assetselector.selector.$textPreviewPanel
    .find('.js-text-preview-content')
    .html(yext.storm.location.util.generateEmbeddedFieldBadges(assetData));
  yext.dam.assetselector.selector.$textPreviewPanel
    .find('.js-asset-labels')
    .html(yext.dam.assetselector.selector.getLabelPreviewMarkup(asset));
  if (asset.description.length) {
    yext.dam.assetselector.selector.$textPreviewPanel
      .find('.js-info-icon')
      .show()
      .contextualHelp({
        basicText: goog.string.htmlEscape(asset.description),
        event: 'hover',
        width: 'auto',
        maxWidth: '150px',
        propagate: true,
      });
  } else {
    yext.dam.assetselector.selector.$textPreviewPanel
      .find('.js-info-icon')
      .hide();
  }
};

/**
 * Returns the markup for the labels that show up in the asset preview
 * @param {!Object} asset - the asset which is being previewed
 * @return {string} - the string representation of the label markup
 */
yext.dam.assetselector.selector.getLabelPreviewMarkup = function(asset) {
  var labels = '';
  for (var i = 0; i < asset.labels.length; i++) {
    labels += yext.dam.labels.view.buildViewLabelHtml(asset.labels[i].name);
  }
  return labels;
};

/**
 * Create image object, size to fit a container and provide a callback
 * when the image is loaded
 *
 * @param {string} src Image source
 * @param {number} width The width of the container for this image
 * @param {number} height The height of the container for this image
 * @param {function()} cb A callback that is triggered when the image is loaded
 * @return {!Image}
 */
yext.dam.assetselector.selector.image = function(src, width, height, cb) {
  var img = new Image();
  img.style.display = 'none';
  img.onload = function() {
    $(this).fadeIn(400);
    if (typeof cb == 'function') {
      cb();
    }
  };
  img.src = yext.getDynamicThumbnailUrl(src, width, height);
  return img;
};

/**
 * Create video object, size to fit a container and provide a callback
 * when the image is loaded
 *
 * @param {string} src video thumbnil image source
 * @param {number} width The width of the container for this video thumbnil image
 * @param {number} height The height of the container for this video thumbnil image
 * @param {function()} cb A callback that is triggered when the video thumbnil image is loaded
 * @return {!Image}
 */
yext.dam.assetselector.selector.video = function(src, width, height, cb) {
  var img = new Image();
  img.style.display = 'none';
  img.onload = function() {
    yext.sizeImage(this, width, height);
    $(this).fadeIn(400);
    if (yext.isFunction(cb)) {
      cb(img);
    }
  };

  var id = yext.youtube.parseIdFromUrl(src);
  img.src = yext.youtube.getYoutubeThumbnailUrl(id);
  return img;
};

/**
 * Reset the selector module
 */
yext.dam.assetselector.selector.reset = function() {
  yext.dam.assetselector.selector.$assetList.html('');
  yext.dam.asset.destroyAll();
  yext.dam.assetselector.selector.selected = undefined;
  yext.dam.assetselector.selector.resetPreview();
};

/**
 * Get asset by DOM element
 *
 * @param {!jQuery} $asset The thumbnail element from which to select the asset
 * @return {?yext.dam.asset.Asset}
 */
yext.dam.assetselector.selector.getAsset = function($asset) {
  var UID = $asset.data(yext.dam.assetselector.selector.UIDString);
  return yext.dam.asset.get(UID);
};

/**
 * updates the dialog for the crop view
 */
yext.dam.assetselector.selector.setCropState = function() {
  var $dialogTitle = yext.dam.assetselector.selector.$context.closest('.ui-dialog').find('.ui-dialog-title');
  yext.dam.assetselector.selector.originalTitle = $dialogTitle.text();
  $dialogTitle.text(yext.msg('Crop Photo'));
  // add a class to the dialog to indicate state for styling
  yext.dam.assetselector.selector.$context.addClass('crop-state');
  yext.imageloader.$container.closest('.js-image-loader-wrap').hide();
};
